import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Wrench, Scissors, Wind, Trees, Leaf, Building2, Droplets, FlowerIcon, SprayCanIcon, SproutIcon, TreeDeciduousIcon, FenceIcon } from 'lucide-react';
const services = [{
  icon: Scissors,
  title: 'Professional Mowing & Precision Edging',
  description: 'Clean lines, perfect edges. The kind of cut that makes your neighbors ask who did it.'
}, {
  icon: Trees,
  title: 'Trimming & Removing Trees',
  description: 'From shaping overgrown trees to full removal, we handle it safely and leave your yard spotless.'
}, {
  icon: Leaf,
  title: 'Trimming Bushes & Hedges',
  description: 'We shape and maintain your bushes and hedges to keep your property looking sharp and well-kept.'
}, {
  icon: Droplets,
  title: 'Drainage Solutions',
  description: 'We install drainage systems to protect your property from flooding and water damage.'
}, {
  icon: FlowerIcon,
  title: 'Flower Beds & Plant Service',
  description: 'Beautiful flower beds and plant installations that add color and life to your landscape.'
}, {
  icon: SproutIcon,
  title: 'Mulch & Landscaping Installation',
  description: "We install mulch, plants, and bed designs that double your home's curb appeal."
}, {
  icon: Wind,
  title: 'Full Cleanup & Blowing',
  description: 'We leave your property without a single leaf out of place. When we show up, you can tell we were there.'
}, {
  icon: SprayCanIcon,
  title: 'Pressure Washing',
  description: 'Driveways, sidewalks, patios, and fences — we blast away dirt and grime to make surfaces look brand new.'
}, {
  icon: Wrench,
  title: 'Sprinkler System Install & Repair',
  description: 'We install new sprinkler systems and repair existing ones to keep your lawn watered efficiently.'
}, {
  icon: TreeDeciduousIcon,
  title: 'New Grass Installation',
  description: 'Whether sod or seed, we install fresh grass to give your yard a lush, green start.'
}, {
  icon: FenceIcon,
  title: 'Weed Control & Fertilization',
  description: 'We attack the problem at the root so your grass stays green and healthy year-round in the Texas climate.'
}, {
  icon: Building2,
  title: 'Residential & Commercial Service',
  description: 'Houses, condos, offices, commercial properties. If it has grass, we transform it.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ServicesSection() {
  return <section id="services" className="py-16 md:py-24 bg-[#f9f7f2]" data-id="element-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-302">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#2D5A27]/10 text-[#2D5A27] mb-6" data-id="element-303">
            <Wrench className="w-8 h-8" data-id="element-304" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-6" data-id="element-305">
            WHAT WE DO FOR YOUR PROPERTY
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-306">
            We don't just "mow and go." We offer a full range of services to
            transform your property.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-307">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-308">
              <div className="w-14 h-14 rounded-xl bg-[#f9f7f2] flex items-center justify-center text-[#2D5A27] mb-6" data-id="element-309">
                <service.icon className="w-7 h-7" data-id="element-310" />
              </div>
              <h3 className="text-xl font-bold text-[#1B2E1B] mb-4 leading-tight" data-id="element-311">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-312">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}